// ** React Imports
import { useState, useCallback, useEffect } from 'react';

// ** Todo App Components
import Questions from './Questions';
import Sidebar from './Sidebar';
import QuestionSidebar from './QuestionSidebar';

// ** Store & Actions

import { Button, Col, Row } from 'reactstrap';
import '@styles/react/apps/app-todo.scss';
import { makeUniqueId } from '@apollo/client/utilities';

const TODO = ({ form, editMode, handleOnSubmit }) => {
  const _data = new Map();
  // ** States
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState({});
  const [openQuestionSidebar, setOpenQuestionSidebar] = useState(false);
  // ** URL Params

  // ** Function to handle Left sidebar & Question sidebar
  const handleQuestionSidebar = () =>
    setOpenQuestionSidebar(!openQuestionSidebar);

  const handleAddQuestions = useCallback((newData) => {
    [...questions, ...newData].forEach((item, idx) => {
      if (item._id) {
        _data.set(item._id, item);
      } else {
        item._id = makeUniqueId(idx);
        _data.set(item._id, item);
      }
    });

    setQuestions([..._data.values()]);
    // _data.clear();
  }, []);

  const handleRemoveQuestion = (id) => {
    setQuestions([...questions.filter((item) => item._id !== id)]);
  };

  const handleSubmit = () => {
    handleOnSubmit(
      {
        form: questions.map(({ question, type, answers }) => ({
          question,
          type,
          answers
        }))
      },
      true
    );
  };

  // ** Get Questions on mount & based on dependency change
  useEffect(() => {
    handleAddQuestions(form || []);
  }, [handleAddQuestions]);

  return (
    <>
      <Row>
        <Col md={1}>
          <Sidebar
            // getQuestions={getQuestions}
            setSelectedQuestion={() => setSelectedQuestion({})}
            handleQuestionSidebar={handleQuestionSidebar}
          />
        </Col>
        <Col>
          <div className="content-right">
            <div className="content-wrapper">
              <div className="content-body">
                <Questions
                  questions={questions}
                  setQuestions={setQuestions}
                  setSelectedQuestion={setSelectedQuestion}
                  handleQuestionSidebar={handleQuestionSidebar}
                />
                <QuestionSidebar
                  selectedQuestion={selectedQuestion}
                  // addQuestion={addQuestion}
                  open={openQuestionSidebar}
                  handleRemoveQuestion={handleRemoveQuestion}
                  // updateQuestion={updateQuestion}
                  handleAddQuestions={handleAddQuestions}
                  // selectQuestion={selectQuestion}
                  // deleteQuestion={deleteQuestion}
                  handleQuestionSidebar={handleQuestionSidebar}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={10} />
        <Col lg={2} className="d-flex justify-content-end align-items-end">
          <Button
            type="submit"
            onClick={handleSubmit}
            color="success"
            className="mt-1 w-100"
          >
            {editMode ? 'Guardar' : 'Crear'}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default TODO;
